angular.module('picmonic-common').factory('RuptService', [
  '$cookies',
  function ($cookies) {
    return {
      setUserInfo: function (user) {
        if (user.user_id && !$cookies.get('pls_original_user')) {
          Rupt.attach({
            client_id: window.pls_config.rupt_client_id,
            account: '' + user.user_id,
            email: user.email, // Optional
            //phone: "user_phone", // Optional
            // redirect_urls: {
            //     logout_url: "/logout",
            //     new_account_url: "/?register=1",
            // },
            //debug: true,
          });
        } else {
          // await Rupt.detach({
          //   client_id: `client_id`,
          //   account: `account_id`,
          //   device: `device_id`,
          // });
        }
      },
    };
  },
]);
